import { render, staticRenderFns } from "./BusinessCategoriesView.vue?vue&type=template&id=bcfd6a4a&"
import script from "./BusinessCategoriesView.vue?vue&type=script&lang=ts&"
export * from "./BusinessCategoriesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports